module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_3009.95c4b5d3.png";